import VideoPlayerPage from './VideoPlayerPage';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

VideoPlayerPage.schema = schema;
VideoPlayerPage.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default VideoPlayerPage;
